(function($){
    Drupal.behaviors.mo20 = {
        attach() {

            // Key used to store player state in browser storage
            const localStateKey = 'ukho--bkg-video--prevent-autoplay';

            // UI elements
            const $videoPlayer = $('.MO20__bkg-video');
            const $playButton = $('.MO20__playback-button--play');
            const $pauseButton = $('.MO20__playback-button--pause');


            function setPlayerState(autoplay) {
                // Set/remove state into browser storage so users don't have to pause on each load
                if (autoplay) {
                    localStorage.removeItem(localStateKey);
                } else {
                    localStorage.setItem(localStateKey, autoplay);
                }
                updateUI(autoplay);
            }

            function shouldAutoplay() {
                return !localStorage.getItem(localStateKey);
            }

            function toggleVideoState(play) {
                play ? $videoPlayer[0].play() : $videoPlayer[0].pause();
                setPlayerState(play);
            }

            function updateUI(playing) {
                $playButton.attr('disabled', true);
                $pauseButton.attr('disabled', true);

                if (playing) {
                    $pauseButton.attr('disabled', false);
                } else {
                    $playButton.attr('disabled', false);
                }
            }

            function initVideo() {
                const autoplay = shouldAutoplay();
                if (!autoplay) {
                    // Pause video if user paused it previously
                    $videoPlayer[0].pause();
                }
                updateUI(autoplay);
            }

            if ($videoPlayer.length > 0) {
                // Initialise our video player if already loaded
                if ($videoPlayer[0].readyState === 4) {
                    initVideo();
                } else {
                    // If not, wait until it has
                    $videoPlayer.on('loadeddata', function(e) {
                        initVideo();
                    });
                }
            }

            $playButton.click(function(e){
                toggleVideoState(true);
            });

            $pauseButton.click(function(e){
                toggleVideoState(false);
            });
        }
    };
})(jQuery);
